import {Component} from '@angular/core';


declare const window: any;

@Component({
    selector: 'app-add-this',
    templateUrl: './add-this.component.html',
    styleUrls: ['./add-this.component.scss']
})
export class AddThisComponent {

    addthis_share = window.addthis_share ??= {};

    parse = new Proxy({} as any, {
        set(target, p, value) {
            try {
                window.addthis_share[p] = JSON.parse(value);
            } catch (e) {
            }
            target[p] = value;
            return true;
        }
    });

    loaded = false;

    title;
    description;
    media;
    url;

    load() {
        this.loaded = false;
        setTimeout(() => {
            this.loaded = true;
        }, 1000);
    }
}
